import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SadFaceIcon from 'Components/icons/SadFaceIcon';

import './EmptyState.scss';

const EmptyState = ({ extraClass, translations }) => {
  const wrapperClass = classnames('empty-state', {
    [extraClass]: extraClass,
  });
  const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  return (
    <div className={wrapperClass}>
      <div className="white-circle">
        <SadFaceIcon success />
      </div>
       <div className={`empty-state__title${acquirerCode}`}> 
        {translations.emptyStateHeading}
      </div>
      <div className="empty-state__description">
        {translations.emptyStateDescription }
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  extraClass: PropTypes.string,
  translations: PropTypes.object.isRequired,
  acquirer: PropTypes.string,
};

EmptyState.defaultProps = {
  extraClass: '',
  acquirer: '',
};

export default EmptyState;
